import React, { Component } from 'react';
import { connect } from "react-redux";
import { MenuAdministrar } from "./bienestar_estudiantil/components/BienestarMenu";
import ConsultaEstudiante from "./bienestar_estudiantil/components/ConsultaEstudiante";
import { BtnDetalle, 
    BtnRegresar, 
    BtnGestionar, 
    BtnBiblioteca, 
    BtnFolder, 
    BtnObservacion,
    BtnAsigPersona,
    BtnEncender,
    BtnApagar,
} from "../general/BotonesAccion";
import { 
    mostrarModalDetalleBienestar,
    mostrarModalGestionarBienestar, 
    mostrarModalObservacionBienestar, 
    mostrarModalAddFiltrosBienestar, 
    mostrarModalMaterialApoyoBienestar, 
    mostrarModalFormatosBienestar, 
    mostrarModalDetalleBienestarFormatos,
    mostrarModalAsignarProfesionalBienestar,
} from "../../redux/actions/actBienestar";
import { actualizarMensaje, mostrarModulo } from "../../redux/actions/actGlobal";
import { 
    mostrarError, 
    obtenerValoresFiltros, 
    coloresEmma, 
    obtenerPermisosValorAlt 
} from "../../global/js/funciones";
import {
    fetchEstadosSolicitudesBienestar,
    fetchSolicitudesBienestarAdmin,
    postGestionarProcesoBienestar,
    postCrearObservacionBienestar,
    postAvisoDisentimiento,
} from "./bienestar_estudiantil/services/bienestarAdministrarService";
import {
    COLORES_ESTADO,
    COD_ESTADO_TODOS,
    COD_ESTADO_CIERRE,
    COD_ESTADO_ATENDIDO,
    COD_ESTADO_AGENDAMIENTO,
    COD_ESTADO_GESTION,
    COD_CRISIS,
    COD_SOCIOEMOCIONAL,
    PERFIL_ADMIN,
    PERFIL_ADMIN_BIENESTAR,
    PERFIL_PSICOLOGO,
} from './helper';
import DialogAvisoDisentimiento from './bienestar_estudiantil/components/detalle/DialogAvisoDisentimiento';
import { puedeVerContenidoBienestar, obtenerProfesionalAsignadoId } from './bienestar_estudiantil/helpers/bienestarAccesoPermisos';
import { nivelDeSolicitud, estiloRiesgo } from './bienestar_estudiantil/helpers/factorRiesgoUtils';
import ChipFactorRiesgo from './bienestar_estudiantil/components/ChipFactorRiesgo';
import {
    Grid,
    Paper,
    Tooltip,
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    CircularProgress,
} from '@material-ui/core';
import TareasTerminadas from "../general/TareasTerminadas";
import ListarDatos from "../general/ListarDatos";
import BienestarDetalle from "./bienestar_estudiantil/components/BienestarDetalle";
import BienestarArchivosAdjuntos from "./bienestar_estudiantil/components/BienestarMaterialApoyo";
import TituloAccion from "../general/TituloAccion";
import AccionesRapidas from "../general/AccionesRapidas";
import BienestarGestionar from "./BienestarGestionar";
import BienestarFiltro from "./bienestar_estudiantil/bienestarFiltro";
import moment from 'moment';
import BienestarPermisos from './bienestar_estudiantil/BienestarPermisos';
import HorarioAtencionBienestar from './bienestar_estudiantil/components/HorarioAtencionBienestar';
import emma_w from '../../global/imagenes/emma_w.png';
import emma_s1 from '../../global/imagenes/emma_s1.png';
import FilterListIcon from '@material-ui/icons/FilterList';

class BienestarEstAdministrar extends Component {

    constructor(props) {
        super(props);
        this.state = {
            menu: false,
            seleccion: 'proceso',
            accion: 'Procesos',
            accionProceso: 'inicio',
            id_bien_est: null,
            dataProcesoActual: null,
            historial: null,
            cargando: true,
            administrador: false,
            estados_procesos: [],
            periodo: '',
            periodo_filtro: null,
            solicitudes_activos: [],
            id_estado_actual: null,
            id_proceso_actual: null,
            tipo_modal: null,
            filtros_actuales: [],
            avisoDisentimientoDialogo: false,
            avisoDisentimientoConfirmSimple: false,
            avisoDisentimientoRow: null,
            avisoDisentimientoEnviando: false,
        };
    }

    async componentDidMount() {
        let { mostrarModulo } = this.props;
        mostrarModulo({ ruta: '/gestion_bienestar_estudiantil', nombre: 'Bienestar Estudiantil' });
        this.esAdministrador();
        await this.obtenerDatosIniciales();
    }

    async componentDidUpdate(prevProps, prevState) {
        let { accionProceso, periodo } = this.state;
        let { usuario } = this.props;
        if (prevProps.usuario !== usuario) {
            this.esAdministrador();
        }
        if (prevState.accionProceso !== accionProceso) {
            if (accionProceso === 'inicio') {
                await this.obtenerEstadoSolicitudes(periodo);
            } else if (accionProceso !== COD_ESTADO_TODOS) {
                await this.cargarSolicitudesPorEstado(accionProceso);
            }
        }
    }


    obtenerColor = (codigo) => {
        const color = COLORES_ESTADO[codigo] || { backgroundColor: '#B8B8B8', color: '#D9D7D7' };
            return color;
        };

    static PERFILES = {
        ADMIN: PERFIL_ADMIN,
        GESTOR: PERFIL_ADMIN_BIENESTAR,
        PSICOLOGO: PERFIL_PSICOLOGO,
    };
    

    _obtenerCodigoPerfil(codigoPerfil = null) {
        return (codigoPerfil || this.props?.usuario?.perfil?.codigo || '').toString();
    }


    esAdministrador() {
        const codigo = this._obtenerCodigoPerfil();
        if (this.puedeAdministrar(codigo)) {
            this.setState({ administrador: true });
        }
    }


    puedeAdministrar(codigoPerfil = null) {
        const codigo = this._obtenerCodigoPerfil(codigoPerfil);
        const { ADMIN, GESTOR } = BienestarEstAdministrar.PERFILES;
        return codigo === ADMIN || codigo === GESTOR;
    }


    esPsicologo(codigoPerfil = null) {
        return this._obtenerCodigoPerfil(codigoPerfil) === BienestarEstAdministrar.PERFILES.PSICOLOGO;
    }

    /**
     * El gestor administra el profesional de cualquier solicitud; el psicólogo
     * solo se autoasigna, y solo mientras la solicitud no tenga profesional.
     */
    puedeGestionarProfesional(row) {
        const estadosValidos = [COD_ESTADO_GESTION, COD_ESTADO_AGENDAMIENTO, COD_ESTADO_ATENDIDO, COD_ESTADO_CIERRE];
        if (!estadosValidos.includes(String(row.estado_actual?.codigo))) return false;
        if (this.puedeAdministrar()) return true;
        if (!this.esPsicologo()) return false;

        return obtenerProfesionalAsignadoId(row) == null;
    }

    isAdminOrGestor(codigoPerfil = null) {
        const codigo = this._obtenerCodigoPerfil(codigoPerfil);
        const { ADMIN, GESTOR, PSICOLOGO } = BienestarEstAdministrar.PERFILES;
        return codigo === ADMIN || codigo === GESTOR || codigo === PSICOLOGO;
    }


    obtenerEstadosPermitidosPorPerfil(codigoPerfil = null) {
        const codigo = this._obtenerCodigoPerfil(codigoPerfil);
        const { ADMIN, GESTOR, PSICOLOGO } = BienestarEstAdministrar.PERFILES;
        if (codigo === ADMIN || codigo === GESTOR || codigo === PSICOLOGO ) return null;
        return [];
    }


    async obtenerDatosIniciales() {
        this.setState({ cargando: true, enListado: true })
        let periodo = await obtenerValoresFiltros([{ 'llave': 'codigo', 'valor': 'Per_Bienestar' }]);
        let periodoNombre = periodo.length > 0 ? periodo[0].nombre : '';
        this.setState({ periodo: periodoNombre, periodo_filtro: periodoNombre });
        await this.obtenerEstadoSolicitudes(periodoNombre);
    }
    

    async obtenerEstadoSolicitudes(periodo) {
        this.setState({ cargando: true, errorPermisos: false, mensajePermisos: '' });
        const codigoPerfil = this.props.usuario?.perfil?.codigo || '';
        const scope = this.isAdminOrGestor(codigoPerfil) ? 1 : 0;

        const { error, estado, resp } = await fetchEstadosSolicitudesBienestar(periodo, scope);

        if (estado === 401 || (resp && resp.detail)) {
            this.setState({
                estados_procesos: [],
                cargando: false,
                errorPermisos: true,
                mensajePermisos: resp && resp.detail ? resp.detail : 'No tiene permisos asignados para ver estados.'
            });
            return [];
        }

        if (estado === 200 && !error && resp) {
            let { general, extra } = resp;

            if (!Array.isArray(general) || general.length === 0) {
                await this.obtenerDatosInicialesLegacy();
                return [];
            }

            const primerElemento = general[0];
            if (primerElemento && typeof primerElemento.estado_actual === 'object') {
                await this.obtenerDatosInicialesLegacy();
                return [];
            }

            let estados_procesos = general.map(est => ({
                estado_actual__codigo: est.estado_actual__codigo || est.codigo,
                estado_actual__nombre: est.estado_actual__nombre || est.nombre,
                num_sol: est.num_sol || est.solicitudes,
                orden: est.orden
            }));

            if (Array.isArray(extra) && extra.length > 0) {
                extra.forEach(({ solicitudes, nombre, codigo, orden }) => {
                    if (codigo !== COD_ESTADO_TODOS && codigo !== 'Todos') {
                        estados_procesos.push({
                            estado_actual__codigo: codigo,
                            estado_actual__nombre: nombre,
                            num_sol: solicitudes,
                            orden: orden
                        });
                    }
                });
            }

            estados_procesos = estados_procesos.sort((a, b) => a.orden - b.orden);
            const total_solicitudes = estados_procesos.reduce((sum, est) => sum + est.num_sol, 0);
            estados_procesos.unshift({
                estado_actual__codigo: COD_ESTADO_TODOS,
                estado_actual__nombre: 'Todos',
                num_sol: total_solicitudes,
                orden: -1
            });

            this.setState({ estados_procesos, cargando: false, errorPermisos: false, mensajePermisos: '' });
            return estados_procesos;
        }

        await this.obtenerDatosInicialesLegacy();
        return [];
    }
    

    async obtenerDatosInicialesLegacy() {
        let periodo = this.state.periodo;
        let solicitudes = await this.obtenerSolicitudes([{ 'llave': 'periodo', 'valor': periodo }]);
        if (solicitudes && Array.isArray(solicitudes)) {
            let estados_map = {};
            solicitudes.forEach(solicitud => {
                const codigo = solicitud.estado_actual?.codigo;
                const nombre = solicitud.estado_actual?.nombre;
                if (codigo && nombre) {
                    if (!estados_map[codigo]) {
                        estados_map[codigo] = {
                            estado_actual__codigo: codigo,
                            estado_actual__nombre: nombre,
                            num_sol: 0,
                            orden: solicitud.estado_actual?.orden || 0
                        };
                    }
                    estados_map[codigo].num_sol++;
                }
            });
            let estados_procesos = Object.values(estados_map).sort((a, b) => a.orden - b.orden);
            estados_procesos.unshift({
                estado_actual__codigo: COD_ESTADO_TODOS,
                estado_actual__nombre: 'Todos',
                num_sol: solicitudes.length,
                orden: -1
            });
            this.setState({ estados_procesos, cargando: false });
        } else {
            this.setState({ estados_procesos: [], cargando: false });
        }
    }


    async obtenerSolicitudes(filtros = []) {
        const codigoPerfil = this.props.usuario?.perfil?.codigo || '';
        const scope = this.isAdminOrGestor(codigoPerfil) ? 1 : 0;
        return fetchSolicitudesBienestarAdmin(filtros, scope);
    }


    cargarSolicitudesPorEstado = async (codigo) => {
        const { periodo, filtros_actuales } = this.state;
        this.setState({ cargando: true });
        let filtros = [
            { llave: 'periodo', valor: periodo }
        ];
        if (codigo !== COD_ESTADO_TODOS) {
            filtros.push({ llave: 'estado_actual__codigo', valor: codigo });
        }
        if (Array.isArray(filtros_actuales) && filtros_actuales.length > 0) {
            const extras = filtros_actuales.filter(({ llave }) => llave !== 'periodo' && llave !== 'estado_actual__codigo');
            filtros = filtros.concat(extras);
        }
        let solicitudes = await this.obtenerSolicitudes(filtros);
        this.setState({
            solicitudes_activos: solicitudes,
            cargando: false
        });
    }


    configFiltros = (accion_actual) => {
        let { periodo } = this.state;
        switch (accion_actual) {
            case COD_ESTADO_TODOS:
                return [{ 'llave': 'periodo', 'valor': periodo }];
            case 'inicio':
                return [{ 'llave': 'periodo', 'valor': periodo }];
            default:
                return [
                    { 'llave': 'estado_actual__codigo', 'valor': accion_actual },
                    { 'llave': 'periodo', 'valor': periodo }
                ];
        }

    };


    obtenerSolicitudesFiltradas = async (filtros = []) => {
        this.setState({ cargando: true, filtros_actuales: filtros });
        let solicitudes = await this.obtenerSolicitudes(filtros);
        this.setState({
            solicitudes_activos: Array.isArray(solicitudes) ? solicitudes : [],
            cargando: false
        });
    };

    onClickDocumentosExtras = (row) => {
        let { mostrarModalMaterialApoyoBienestar } = this.props;
        this.setState({ tipoModal: 'documentos_extras', dataSolicitud: row, id_estado_actual: row.estado_actual.id }, () => {
            if (typeof mostrarModalMaterialApoyoBienestar === 'function') {
                mostrarModalMaterialApoyoBienestar(true, { tipo: 'documentos_extras' });
            }
        });
    }

    transferirSolicitud = (solicitud) => {
        let { mostrarModalDetalleBienestar } = this.props;
            this.setState({
                seleccion: 'proceso',
                accionProceso: COD_ESTADO_TODOS,
                filtros_actuales: [{ llave: 'id', valor: solicitud.id }],
                dataSolicitud: solicitud
            }, async () => {
                await this.obtenerSolicitudesFiltradas([{ llave: 'id', valor: solicitud.id }]);
                if (typeof mostrarModalDetalleBienestar === 'function') {
                    mostrarModalDetalleBienestar(false);
                }
            });
        }


    pintarListaProceso(){
        let { 
            seleccion,
            accionProceso, 
            solicitudes_activos 
        } = this.state;
        let { 
            mostrarModalDetalleBienestar,
            mostrarModalGestionarBienestar, 
            mostrarModalObservacionBienestar, 
            mostrarModalMaterialApoyoBienestar, 
            mostrarModalAddFiltrosBienestar, 
            mostrarModalFormatosBienestar, 
            mostrarModalAsignarProfesionalBienestar, 
        } = this.props;

        const acciones = (row) => {
            const codigoEstadoActual = row.estado_actual?.codigo;
            const tienePermisoGestionar = row.permiso === 1;

            const onClickDetalle = () => {
                this.setState({ dataSolicitud: row }, () => {
                    mostrarModalDetalleBienestar(true);
                });
            };
            const onClickGestionar = () => {
                this.setState({ tipoModal: 'gestionar', dataSolicitud: row, id_estado_actual: row.estado_actual.id}, () => {
                    mostrarModalGestionarBienestar(true);
                });
            };
            const onClickObservacion = () => {
                this.setState({ tipoModal: 'observacion', dataSolicitud: row, id_estado_actual: row.estado_actual.id}, () => {
                    mostrarModalObservacionBienestar(true);
                });
            }
            const onClickMaterialApoyo = () => {
                this.setState({ tipoModal: 'adjunto', dataSolicitud: row, id_estado_actual: row.estado_actual.id }, () => {
                    mostrarModalMaterialApoyoBienestar(true);
                });
            }
            const onClickFormatoSesiones = () => {
                this.setState({ dataSolicitud: row }, () => {
                    mostrarModalFormatosBienestar(true);
                });
            }
            const onClickModalAsignarProfesional = () => {
                this.setState({ tipoModal: 'asignarProfesional', dataSolicitud: row, id_estado_actual: row.estado_actual.id}, () => {
                    mostrarModalAsignarProfesionalBienestar(true);
                });
            };

            return (
                <div>
                    <BtnDetalle callback={onClickDetalle} color='#01579b' texto='Detalle' />
                    { tienePermisoGestionar && (<BtnObservacion callback={onClickObservacion} color='#696968ff' texto='Nueva observación' />)}
                    { codigoEstadoActual !== COD_ESTADO_CIERRE && tienePermisoGestionar && (<BtnGestionar callback={onClickGestionar} color='#00bfa5' texto='Gestionar' />)}
                    { codigoEstadoActual === COD_ESTADO_ATENDIDO && tienePermisoGestionar && (<BtnFolder callback={onClickMaterialApoyo} color='#f8e962ff' texto='Material de Apoyo' />)}
                    {(codigoEstadoActual === COD_ESTADO_ATENDIDO || codigoEstadoActual === COD_ESTADO_CIERRE) && tienePermisoGestionar && (<BtnBiblioteca callback={onClickFormatoSesiones} color='#696968ff' texto='Formatos' />)}
                    {this.puedeGestionarProfesional(row) && tienePermisoGestionar && (
                        <BtnAsigPersona
                            callback={onClickModalAsignarProfesional}
                            color='#696968ff'
                            texto={this.esPsicologo() ? 'Asignarme esta solicitud' : 'Gestionar profesional'}
                        />
                    )}
                    {/* Aviso de disentimiento: solo tiene sentido cuando el proceso ya
                        se cerro, que es cuando el estudiante debe diligenciar el formato. */}
                    {codigoEstadoActual === COD_ESTADO_CIERRE && this.puedeAdministrar() && (
                        row.aviso_disentimiento
                            ? <BtnApagar callback={() => this.cambiarAvisoDisentimiento(row, false)} texto='Desactivar aviso de disentimiento' />
                            : <BtnEncender callback={() => this.cambiarAvisoDisentimiento(row, true)} texto='Enviar aviso de disentimiento' />
                    )}
                </div>
            );
        };
        return (
            <div>
                {seleccion === 'proceso' && accionProceso !== 'inicio' && (
                    <div className="regresar">
                        <BtnRegresar callback={() => this.setState({ accionProceso: 'inicio', filtros_actuales: [] })} />
                    </div>
                    )}
                {seleccion === 'proceso' && accionProceso === 'inicio'}
                    <ListarDatos
                        datos={solicitudes_activos}
                        titulo='Lista de Solicitudes'
                        id="id"
                        opciones={true}
                        acciones={acciones}
                        buscar={true}
                        filtrar={true}
                        refrescar={true}
                        descargar='SOLICITUDES - BIENESTAR'
                        actRefrescar={() => {
                            if (accionProceso && accionProceso !== 'inicio') {
                                this.cargarSolicitudesPorEstado(accionProceso);
                            } else {
                                this.obtenerDatosIniciales();
                            }
                        }}
                        actfiltrar={() => mostrarModalAddFiltrosBienestar(true, true)}
                        avatar={(row) => (
                            estiloRiesgo(nivelDeSolicitud(row))
                                ? '!'
                                : row.estado_actual?.nombre?.charAt(0).toUpperCase()
                        )}
                        color_avatar={(row) => (
                            estiloRiesgo(nivelDeSolicitud(row))
                            || COLORES_ESTADO[row.estado_actual?.codigo]
                            || { backgroundColor: '#B8B8B8', color: '#D9D7D7' }
                        )}
                        fila_principal={(row) => `${row.usuario_registro?.primer_nombre} ${row.usuario_registro?.segundo_nombre ?? ''} ${row.usuario_registro?.primer_apellido} ${row.usuario_registro?.segundo_apellido ?? ''}` }
                        insignia={(row) => <ChipFactorRiesgo factor={row.factor_riesgo} posicion="derecha" />}
                        filas={[
                            { mostrar: (row) => row.usuario_registro?.nombre },
                            { mostrar: (row) => row.tipo_servicio?.nombre },
                            { nombre: "Motivo: ", mostrar: (row) => row.factor_riesgo?.nombre },
                            {
                                mostrar: (row) => row.aviso_disentimiento && (
                                    <span style={{ color: '#e65100', fontWeight: 500 }}>
                                        {row.aviso_disentimiento_incluye_traslado_eps
                                            ? 'Aviso de disentimiento activo (normal + traslado EPS)'
                                            : 'Aviso de disentimiento activo'}
                                    </span>
                                ),
                            },
                            { nombre: "Estado: ", mostrar: (row) => row.estado_actual?.nombre },
                            { nombre: "Población: ", mostrar: (row) => row.poblacion?.nombre || 'No aplica' },
                            { nombre: "Fecha Registro: ", mostrar: (row) => moment(row.fecha_registro).format('YYYY-MM-DD, h:mm a') },
                        ]}
                        funcion_detalle={(row) => this.setState({ dataSolicitud: row }, () => {
                            mostrarModalDetalleBienestar(true);
                        })}
                    />
                    <DialogAvisoDisentimiento
                        open={this.state.avisoDisentimientoDialogo}
                        enviando={this.state.avisoDisentimientoEnviando}
                        onClose={this.cerrarDialogoAvisoDisentimiento}
                        onConfirmar={this.confirmarDialogoAvisoDisentimiento}
                    />
                    <Dialog
                        open={this.state.avisoDisentimientoConfirmSimple}
                        onClose={this.cerrarConfirmSimpleAvisoDisentimiento}
                        maxWidth="xs"
                        fullWidth
                        aria-labelledby="bienestar-confirmar-aviso-disentimiento"
                    >
                        <DialogTitle id="bienestar-confirmar-aviso-disentimiento">¡ Aviso de disentimiento !</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                {`¿Seguro que quieres enviar el aviso de disentimiento a ${this.nombreEstudianteAviso()}?`}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={this.cerrarConfirmSimpleAvisoDisentimiento} disabled={this.state.avisoDisentimientoEnviando}>Cancelar</Button>
                            <div style={{ position: 'relative' }}>
                                <Button
                                    color="primary"
                                    variant="contained"
                                    onClick={this.confirmarSimpleAvisoDisentimiento}
                                    disabled={this.state.avisoDisentimientoEnviando}
                                >
                                    Confirmar
                                </Button>
                                {this.state.avisoDisentimientoEnviando && (
                                    <CircularProgress
                                        size={24}
                                        style={{ position: 'absolute', top: '50%', left: '50%', marginTop: -12, marginLeft: -12 }}
                                    />
                                )}
                            </div>
                        </DialogActions>
                    </Dialog>
            </div>
        )
    }


    /**
     * Enciende o apaga el aviso de disentimiento de una solicitud. El estudiante
     * lo ve al ingresar a EMMA y deja de verlo cuando diligencia el formato.
     *
     * Solo Crisis y Socioemocional tienen disponible el disentimiento de Traslado
     * EPS ademas del normal (ver BienestarFormatosContenido); por eso solo para
     * esos dos servicios se pregunta el alcance antes de activar. Para el resto se
     * pide una confirmacion simple (es una notificacion real al estudiante, no debe
     * salir con un clic accidental). Desactivar se mantiene directo de un clic,
     * igual que hoy.
     */
    cambiarAvisoDisentimiento = (row, activar) => {
        if (!activar) {
            this.ejecutarCambioAvisoDisentimiento(row, false, false);
            return;
        }

        const codigoServicio = row.tipo_servicio?.codigo;
        const requiereEleccionAlcance = codigoServicio === COD_CRISIS || codigoServicio === COD_SOCIOEMOCIONAL;

        if (requiereEleccionAlcance) {
            this.setState({ avisoDisentimientoDialogo: true, avisoDisentimientoRow: row });
        } else {
            this.setState({ avisoDisentimientoConfirmSimple: true, avisoDisentimientoRow: row });
        }
    };

    ejecutarCambioAvisoDisentimiento = async (row, activar, incluirTrasladoEps) => {
        const { actualizarMensaje } = this.props;
        const { estado, resp } = await postAvisoDisentimiento(row.id, activar, incluirTrasladoEps);
        if (estado === 200) {
            actualizarMensaje({
                titulo: resp.titulo,
                tipo: 'success',
                mostrar: true,
                tiempo: 4000,
            });
            const { accionProceso } = this.state;
            if (accionProceso && accionProceso !== 'inicio') {
                await this.cargarSolicitudesPorEstado(accionProceso);
            }
            return true;
        }
        actualizarMensaje({
            titulo: (resp && resp.titulo) || 'No se pudo gestionar el aviso.',
            tipo: 'info',
            mostrar: true,
            tiempo: 5000,
        });
        return false;
    };

    cerrarDialogoAvisoDisentimiento = () => {
        if (this.state.avisoDisentimientoEnviando) return;
        this.setState({ avisoDisentimientoDialogo: false, avisoDisentimientoRow: null });
    };

    confirmarDialogoAvisoDisentimiento = async (incluirTrasladoEps) => {
        const { avisoDisentimientoRow } = this.state;
        if (!avisoDisentimientoRow) return;
        this.setState({ avisoDisentimientoEnviando: true });
        const ok = await this.ejecutarCambioAvisoDisentimiento(avisoDisentimientoRow, true, incluirTrasladoEps);
        this.setState({ avisoDisentimientoEnviando: false });
        if (ok) {
            this.setState({ avisoDisentimientoDialogo: false, avisoDisentimientoRow: null });
        }
    };

    nombreEstudianteAviso = () => {
        const ur = this.state.avisoDisentimientoRow?.usuario_registro || {};
        const nombre = [ur.primer_nombre, ur.segundo_nombre, ur.primer_apellido, ur.segundo_apellido]
            .filter((parte) => parte != null && String(parte).trim() !== '')
            .join(' ');
        return nombre || 'este estudiante';
    };

    cerrarConfirmSimpleAvisoDisentimiento = () => {
        if (this.state.avisoDisentimientoEnviando) return;
        this.setState({ avisoDisentimientoConfirmSimple: false, avisoDisentimientoRow: null });
    };

    confirmarSimpleAvisoDisentimiento = async () => {
        const { avisoDisentimientoRow } = this.state;
        if (!avisoDisentimientoRow) return;
        this.setState({ avisoDisentimientoEnviando: true });
        const ok = await this.ejecutarCambioAvisoDisentimiento(avisoDisentimientoRow, true, false);
        this.setState({ avisoDisentimientoEnviando: false });
        if (ok) {
            this.setState({ avisoDisentimientoConfirmSimple: false, avisoDisentimientoRow: null });
        }
    };


    gestionarProceso = async (id_proceso_actual, data, callback) => {
        const { error, estado, resp } = await postGestionarProcesoBienestar(id_proceso_actual, data);
        let titulo = 'Ha ocurrido un error, contacte con el administrador.';
        let tipo = 'error';
        if (!error) {
            if (estado === 200) {
                tipo = 'success';
                titulo = resp.titulo;
                this.props.mostrarModalGestionarBienestar(false);
                await new Promise(resolve => setTimeout(resolve, 200));
                await this.cargarSolicitudesPorEstado(this.state.accionProceso);
                await this.obtenerDatosIniciales();
            } else {
                tipo = 'info';
                titulo = resp.titulo ? resp.titulo : mostrarError(resp);
            }
        }
        this.props.actualizarMensaje({ titulo, tipo, mostrar: true, tiempo: 3000 });
        if (callback) callback();
    };


    crearObservacion = async (bienestar_id, data, callback) => {
        const { error, estado, resp } = await postCrearObservacionBienestar(bienestar_id, data);
        let titulo = 'Ha ocurrido un error.';
        let tipo = 'error';
        if (!error) {
            if (estado === 201) {
                tipo = 'success';
                titulo = 'Observación registrada correctamente';
                this.props.mostrarModalObservacionBienestar(false);
                await this.cargarSolicitudesPorEstado(this.state.accionProceso);
                await this.obtenerDatosIniciales();
            } else {
                tipo = 'info';
                titulo = resp.mensaje || mostrarError(resp);
            }
        }
        this.props.actualizarMensaje({ 
            titulo, tipo, mostrar: true, tiempo: 3000 
        });
        if (callback) callback();
    };


    pintarInicioProcesos = () => {
        let { estados_procesos, errorPermisos, mensajePermisos, cargando } = this.state;
        let { usuario, mostrarModalAddFiltrosBienestar } = this.props;
        const codigoPerfil = usuario?.perfil?.codigo || '';
        const estadosPermitidos = this.obtenerEstadosPermitidosPorPerfil(codigoPerfil);

        if (errorPermisos) {
            return (
                <TareasTerminadas mensaje={mensajePermisos || 'No tiene permisos asignados para ver estados.'} marginTop='7%' imagen={emma_s1} widthImg="7%" />
            );
        }

        let estadosFiltrados = estados_procesos;
        if (estadosPermitidos !== null) {
            estadosFiltrados = estados_procesos.filter(({ estado_actual__codigo }) => 
                estadosPermitidos.includes(estado_actual__codigo)
            );
        }

        const handleClick = (codigo) => {
            if (codigo === COD_ESTADO_TODOS) {
                mostrarModalAddFiltrosBienestar(true);
                return;
            }
            this.setState({ accionProceso: codigo });
        };

        return (
            <>
                <div style={{ padding: '2% 2% 0% 2%' }} >
                    <Grid container direction={'row'} spacing={1} justify={'center'} >
                        <Grid item xs={12} sm={12} md={12} lg={10} >
                            <Grid container direction={'row'} alignItems="center" spacing={1} style={{ width: "100%" }}>
                                <Grid item xs={6} sm={6} md={6} lg={6} >
                                    <TituloAccion principal='' alterno='Seleccione el estado a gestionar: ' />
                                </Grid>
                                <Grid item xs={6} sm={6} md={6} lg={6} >
                                    <Tooltip title='Filtrar' aria-label="add" onClick={() => this.props.mostrarModalAddFiltrosBienestar(true, false)} >
                                        <IconButton edge={false} color="secondary" style={{ float: 'right' }}><FilterListIcon /></IconButton>
                                    </Tooltip>
                                </Grid>
                            </Grid>
                            <Paper elevation={0} square className="scroll contenido_fijo">
                                { (!cargando && estadosFiltrados.length === 0) ?
                                <TareasTerminadas mensaje='Aún no hay solicitudes para este periodo.' marginTop='7%' imagen={emma_s1} widthImg="7%" /> :
                                <Grid container direction={'row'} spacing={1} style={{ width: "100%" }}>
                                    {estadosFiltrados.map(({ estado_actual__codigo: codigo, estado_actual__nombre: nombre, num_sol}, i) => {
                                        return (
                                            <Grid item xs={12} sm={12} md={6} lg={6} key={i}>
                                                <Paper elevation={1} style={{ border: '1px solid #e0e0e0' }} onClick={() => handleClick(codigo)}>
                                                    <AccionesRapidas imagen='' titulo={`¡ ${nombre} !`} sub_titulo='' des_sub_titulo='' avatar={this.obtenerColor(codigo)} avatar_name={nombre.charAt(0).toUpperCase()} list_desc={codigo === COD_ESTADO_TODOS ? ['Debe aplicar los filtros.'] : [`Número de Solicitudes: ${num_sol}`] }/>
                                                </Paper>
                                            </Grid>
                                        )
                                    })}
                                </Grid>
                                }
                            </Paper>
                        </Grid>
                    </Grid>
                </div>
            </>
        )
    }


    pintarAdministrar(){
        let { actualizarMensaje } = this.props;
        return(
            <>
                <div style={{ padding: '20px 20px 0' }}>
                    <HorarioAtencionBienestar actualizarMensaje={actualizarMensaje} />
                </div>
                <BienestarPermisos />
            </>
        )
    }


    render() {
        let { seleccion, 
            cargando, 
            dataSolicitud, 
            accionProceso, 
            id_estado_actual, 
            administrador, 
            tipoModal, 
            periodo 
        } = this.state;
        let { modalMaterialApoyoBienestar, 
            modalDetalleBienestar, 
            mostrarModalDetalleBienestar, 
            actualizarMensaje, 
            modalGestionarBienestar, 
            modalObservacionBienestar, 
            modalAddFiltrosBienestar, 
            modalFormatosBienestar, 
            modalDetalleBienestarFormatos, 
            modalAsignarProfesionalBienestar,
            mostrarModalMaterialApoyoBienestar, 
            mostrarModalDetalleBienestarFormatos, 
            mostrarModalGestionarBienestar, 
            mostrarModalObservacionBienestar, 
            mostrarModalAddFiltrosBienestar, 
            mostrarModalFormatosBienestar,
            mostrarModalAsignarProfesionalBienestar,
            usuario,
            mostrarCampos
         } = this.props;
        return (
            <div>
                <MenuAdministrar
                    seleccionar={(seleccion) => {
                        if (seleccion === 'proceso') {
                            this.setState({
                                seleccion: 'proceso',
                                accionProceso: 'inicio',
                                filtros_actuales: []
                            }, async () => {
                                await this.obtenerEstadoSolicitudes(periodo);
                            });
                        } else {
                            this.setState({ seleccion });
                        }
                    }}
                    sele={seleccion}
                    administrador={administrador}
                    perfil={usuario?.perfil?.codigo}
                />
                <div className='contenido_modulo'>
                    <BienestarGestionar
                        modalGestionarBienestar={modalGestionarBienestar}
                        modalObservacionBienestar={modalObservacionBienestar}
                        mostrarModalGestionarBienestar={mostrarModalGestionarBienestar}
                        mostrarModalObservacionBienestar={mostrarModalObservacionBienestar}
                        solicitud={dataSolicitud} 
                        onClickDocumentosExtras={this.onClickDocumentosExtras}
                        id_estado_actual={id_estado_actual ? id_estado_actual : 0}
                        id_proceso_actual={dataSolicitud ? dataSolicitud.id : 0}
                        gestionarProceso={this.gestionarProceso} 
                        crearObservacion={this.crearObservacion}
                    />
                    <BienestarFiltro
                        modalAddFiltrosBienestar={modalAddFiltrosBienestar}
                        mostrarModalAddFiltrosBienestar={mostrarModalAddFiltrosBienestar}
                        actualizarMensaje={actualizarMensaje}
                        limpiar={() => this.obtenerSolicitudesFiltradas(this.configFiltros(accionProceso))}
                        filtrar={(filtros) => this.obtenerSolicitudesFiltradas(this.configFiltros(accionProceso).concat(filtros))}
                        aplicarPeriodo={async (periodoSel) => {
                            this.setState({ periodo: periodoSel, periodo_filtro: periodoSel, accionProceso: 'inicio', filtros_actuales: [] });
                            await this.obtenerEstadoSolicitudes(periodoSel);
                        }}
                        accionProceso={accionProceso}
                        mostrarTodos={(seleccion) => this.setState({ accionProceso: seleccion })}
                        mostrarCampos={mostrarCampos}
                    />
                    <BienestarDetalle
                        modalDetalleBienestar={modalDetalleBienestar}
                        mostrarModalDetalleBienestar={mostrarModalDetalleBienestar}
                        modalFormatosBienestar={modalFormatosBienestar}
                        mostrarModalFormatosBienestar={mostrarModalFormatosBienestar}
                        modalDetalleBienestarFormatos={modalDetalleBienestarFormatos}
                        mostrarModalDetalleBienestarFormatos={mostrarModalDetalleBienestarFormatos}
                        bienestar_id={dataSolicitud ? dataSolicitud.id : 0}
                        modoLectura={true}
                        modoLecturaFases={true}
                        solicitud={dataSolicitud}
                        transferirSolicitud={this.transferirSolicitud}
                        usuario={usuario}
                        actualizarMensaje={actualizarMensaje}
                        modalAsignarProfesionalBienestar={modalAsignarProfesionalBienestar}
                        mostrarModalAsignarProfesionalBienestar={mostrarModalAsignarProfesionalBienestar}
                        recargarSolicitudes={() => {
                            if (accionProceso && accionProceso !== 'inicio') {
                                this.cargarSolicitudesPorEstado(accionProceso);
                            }
                        }}
                    />
                    <BienestarArchivosAdjuntos
                        modalMaterialApoyoBienestar={modalMaterialApoyoBienestar}
                        mostrarModalMaterialApoyoBienestar={mostrarModalMaterialApoyoBienestar}
                        bienestar_id={dataSolicitud ? dataSolicitud.id : 0}
                        actualizarMensaje={actualizarMensaje}
                        tipoModal={tipoModal}
                        puedeVerContenido={puedeVerContenidoBienestar({ usuario, solicitud: dataSolicitud })}
                    />
                    {
                        !cargando
                        ?
                        <div>
                            {seleccion === 'proceso' && accionProceso === 'inicio' && this.pintarInicioProcesos()}
                            {seleccion === 'proceso' && accionProceso !== 'inicio' && this.pintarListaProceso()}
                            {seleccion === 'consulta_estudiante' && <ConsultaEstudiante />}
                            {seleccion === 'administrar' && this.pintarAdministrar()}
                        </div>
                        : <TareasTerminadas mensaje='Cargando..' marginTop='7%' imagen={emma_w} widthImg="7%" cargando={true} />
                    }
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    let { usuario } = state.redGlobal;
    let { modalAddCredito, modalDetalleCredito, modalEncuestaCredito, modalAddAdjuntosCredito, ModalFormuDirecto } = state.redCreditos;
    let { modalDetalleBienestar, modalGestionarBienestar, modalObservacionBienestar, modalAddFiltrosBienestar, modalMaterialApoyoBienestar, modalFormatosBienestar, modalDetalleBienestarFormatos, modalAsignarProfesionalBienestar, mostrarCampos } = state.redBienestar;
    return {
        modalAddCredito,
        modalDetalleCredito,
        modalEncuestaCredito,
        modalAddAdjuntosCredito,
        ModalFormuDirecto,
        usuario,
        modalDetalleBienestar,
        modalGestionarBienestar,
        modalObservacionBienestar,
        modalAddFiltrosBienestar,
        modalMaterialApoyoBienestar,
        modalFormatosBienestar,
        modalDetalleBienestarFormatos,
        modalAsignarProfesionalBienestar,
        mostrarCampos
    };
};

const mapDispatchToProps = {
    actualizarMensaje,
    mostrarModulo,
    mostrarModalDetalleBienestar,
    mostrarModalGestionarBienestar,
    mostrarModalObservacionBienestar,
    mostrarModalAddFiltrosBienestar,
    mostrarModalMaterialApoyoBienestar,
    mostrarModalFormatosBienestar,
    mostrarModalDetalleBienestarFormatos,
    mostrarModalAsignarProfesionalBienestar,
};

export default connect(mapStateToProps, mapDispatchToProps)(BienestarEstAdministrar);